import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {PearlHarbor} from "../PearlHarbor";
import {TimelineLite} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayUtils} from "../utils/ArrayUtils";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/IReelData";
import {PearlHarborGameData} from "../server/PearlHarborData";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";
import {ISymbolData} from "../server/PearlHarborModel";

export class PearlHarborNormalResultPresentation implements FlowStatePresentation {
    private _tl: TimelineLite
    private _stoppedReels: boolean[];

    private skip(): void {
        PearlHarbor.allReelsView.landingTLs.forEach((landingTL: TimelineLite) => {
            landingTL.progress(1);
        });

        if (this._tl) {
            this._tl.timeScale(5);
        }
    }

    private onReelBounce(data: SimpleReelModelEventData) {
        //Play sound maybe?
    }

    private onReelStop(data: SimpleReelModelEventData, flowStateController: FlowStateController) {
        this._stoppedReels[data.reel] = true;
        if (ArrayUtils.isAllTrue(this._stoppedReels)) {
            PearlHarbor.allReelsView.landingTLs.forEach((landingTL: TimelineLite) => {
                landingTL.timeScale(5);
                landingTL.progress(1);
            });
            PearlHarbor.scatterAnimation.stopAnticipation();
            this.completePresentation(flowStateController);
        }
    }

    private completePresentation(flowStateController: FlowStateController) {
        PearlHarbor.scatterAnimation.checkActiveScatter();
        for(let i:number = 0; i<7; i++){
            PearlHarbor.allReelsView.mainReelModels[i].reelView.setSymbolActiveState()
        }
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController): void {
        this._stoppedReels = [false, false, false, false, false, false, false];
        this._tl = new TimelineLite();
        const gameData: PearlHarborGameData = PearlHarbor.model.gameData;

        // #150, #117 we need to enable below skip in order to implement abort
        this._tl.add(() => flowStateController.setSkipCallback(() => this.skip()), 0.1);


            PearlHarbor.allReelsView.landingTLs.length = 0;
            let luckyDrawDuration: number = 0;

            const stopDelay: number = PearlHarbor.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? PearlHarborGameConfig.reelAllInStopDelayFastSpin : PearlHarborGameConfig.reelAllInStopDelay;
            let stopTime: number = 1;
            for (let i: number = 0; i < gameData.reels.length; i++) {
                const reelData: ISymbolData[] = PearlHarbor.model.allSymbolsData[i];
                const reelStopAnimation: TimelineLite = new TimelineLite({
                    delay: luckyDrawDuration
                });

                reelStopAnimation.add(PearlHarbor.allReelsView.mainReelModels[i].stop(reelData));

                PearlHarbor.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data: SimpleReelModelEventData) => this.onReelStop(data, flowStateController));
                PearlHarbor.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.BOUNCE, (data: SimpleReelModelEventData) => this.onReelBounce(data));

                this._tl.add(reelStopAnimation, stopTime);
                stopTime += stopDelay;
            }


        const padding: number = PearlHarbor.gameFlowController.calculatePaddingDuration(this._tl.totalDuration() - 0.1);
        if (padding > 0 && !gameData.luckyDraw) {
            this._tl.shiftChildren(padding);
        }
    }
}

